import React from "react";
import { graphql } from "gatsby";
import { AlertBanner } from "./AlertBanner";
import {
  KontentColorConfig,
  KontentLinks,
  KontentMultiChoice,
  KontentRichText,
  StringValue,
} from "../../types";
import { formatLinks } from "../../lib/links";
import { findActiveAlertBanner } from "./alertBanners";
import { getColor } from "../../lib/color";
import { getMultiChoice } from "../../lib/multichoice";

type AlertBannerStyles = "green_background" | "white_background";
export interface AlertBannerContainerProps {
  data: {
    allKontentItemComponentAlertBanner: {
      nodes: {
        elements: KontentColorConfig & {
          text: KontentRichText;
          publish_date: StringValue;
          unpublish_date: StringValue;
          link_configuration__link: KontentLinks;
          style: KontentMultiChoice<AlertBannerStyles>;
        };
        system: {
          id: string;
          codename: string;
        };
      }[];
    };
  };
}

const AlertBannerContainer: React.FC<AlertBannerContainerProps> = ({
  data,
}) => {
  const alertBanner = findActiveAlertBanner(
    data.allKontentItemComponentAlertBanner?.nodes
  );
  if (!alertBanner) return null;

  const { publish_date, unpublish_date, link_configuration__link, text } =
    alertBanner.elements;
  const id = alertBanner?.system.id;
  const cta = formatLinks(link_configuration__link?.modular_content)[0];
  const style = getMultiChoice(alertBanner.elements.style);

  return (
    <AlertBanner
      id={id}
      text={text}
      style={style}
      publishDate={publish_date.value}
      unpublishDate={unpublish_date.value}
      ctaHref={cta?.href}
      ctaLabel={cta?.label}
      ctaTarget={cta?.target}
      ctaAriaLabel={cta?.ariaLabel}
    ></AlertBanner>
  );
};

export default AlertBannerContainer;

export const AlertBannerQuery = graphql`
  query {
    allKontentItemComponentAlertBanner(
      filter: { system: { workflow_step: { ne: "archived" } } }
      sort: { elements: { publish_date: { value: DESC } } }
    ) {
      nodes {
        system {
          id
          codename
        }
        elements {
          style {
            value {
              codename
            }
          }
          text {
            value
            links {
              url_slug
              type
              codename
              link_id
              url
            }
          }
          link_configuration__link {
            modular_content {
              ...kontentRichTextLink
            }
          }
          publish_date {
            value
          }
          unpublish_date {
            value
          }
        }
      }
    }
  }
`;
